import React from 'react';

const imageUrls = [
  'https://inovaantage.com/wp-content/uploads/2024/02/42-1.jpg',
  'https://inovaantage.com/wp-content/uploads/2024/02/41-1.jpg',
  'https://inovaantage.com/wp-content/uploads/2024/02/40-1.jpeg',
  'https://inovaantage.com/wp-content/uploads/2024/02/39-1.jpg',
  'https://inovaantage.com/wp-content/uploads/2024/02/38-2.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/37-2.jpg',
  'https://inovaantage.com/wp-content/uploads/2024/02/35-2.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/34-3.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/33-3.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/29-2.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/28-1.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/27-2.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/26-1.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/25-1.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/24-1.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/23-2.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/22-2.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/21-2-620x500.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/11-1.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/10-1-620x500.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/9-1.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/8-1-600x500.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/7-2-600x500.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/6-2.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/5-2.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/4-2.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/3-2-600x500.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/36-3.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/2-1.png',
  'https://inovaantage.com/wp-content/uploads/2024/02/1-1-600x500.png',
  'https://inovaantage.com/wp-content/uploads/2024/04/womens-day.jpeg',
];

const InovaantagePosters = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Inovaantage Posters</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1rem' }}>
        {imageUrls.map((url, index) => (
          <img
            key={index}
            src={url}
            alt={`poster-${index + 1}`}
            style={{ width: '200px', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}
          />
        ))}
      </div>
    </div>
  );
};

export default InovaantagePosters;
